__turbopack_context__.v({
  "box": "Manual-module-scss-module__Q7Cuva__box",
  "manual": "Manual-module-scss-module__Q7Cuva__manual",
  "manualItem": "Manual-module-scss-module__Q7Cuva__manualItem",
  "previousManual": "Manual-module-scss-module__Q7Cuva__previousManual",
  "previousManualWrapper": "Manual-module-scss-module__Q7Cuva__previousManualWrapper",
  "title": "Manual-module-scss-module__Q7Cuva__title",
  "titleAppendix": "Manual-module-scss-module__Q7Cuva__titleAppendix",
});
